/**
 * Time helper functions for consistent time calculations across the app
 */

export const seconds = (amount: number): number => amount * 1000;
export const minutes = (amount: number): number => seconds(amount * 60);
export const hours = (amount: number): number => minutes(amount * 60);
export const days = (amount: number): number => hours(amount * 24);

// Common time constants using the helper functions
export const ONE_SECOND = seconds(1);
export const TEN_SECONDS = seconds(10);
export const FIVE_MINUTES = minutes(5);
export const TEN_MINUTES = minutes(10);
export const FIFTEEN_MINUTES = minutes(15);
export const THIRTY_MINUTES = minutes(30);
export const ONE_HOUR = hours(1);
export const ONE_DAY = days(1);
